import React, { useState } from "react";
import { IconButton, Box, Tooltip, Typography } from "@mui/material";
import CustomIcon from "../../../Components/CustomIcon";

const CustomCopyButton = ({ text }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e) => {
    e.stopPropagation(); // prevent map click events
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1200); // hide after 1.2s
  };

  return (
    <Box sx={{ position: "relative", display: "inline-flex", alignItems: "center", pointerEvents: "auto"  }}>
      <IconButton
          disableRipple
          disableTouchRipple
          disableFocusRipple
          sx={{ py: 0, pr: 0 }}
          onClick={handleCopy}
      >
          <CustomIcon name="copy-icon" />
      </IconButton>

      {copied && (
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "100%",
            transform: "translate(8px, -50%)",
            px: 2,
            py: 0.75,
            bgcolor: "#2E2E2E",
            color: "#fff",
            fontSize: "12px",
            borderRadius: "6px",
            whiteSpace: "nowrap",
            zIndex: 1000,
          }}
        >
          <Typography variant="fw400s14cfff">Copied!</Typography>
        </Box>
      )}
    </Box>
  );
};

export default CustomCopyButton;
